import React, { Component } from 'react';
import { Card, CardTitle, CardText } from 'material-ui/Card';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import { List, ListItem } from 'material-ui/List';

const createStaticDocumentList = (staticDocuments, onClick) => {
    const listItems = Object.keys(staticDocuments).map(name => {
        return (
            <MenuItem key={name} primaryText={name} onClick={() => onClick(name)} />
        );
    });

    return (
        <DropDownMenu style={{backgroundColor: 'white' }} >
            {listItems}
        </DropDownMenu>
    );
};

const createSavedDocumentList = (savedDocuments, onClick) => {
    const listItems = Object.keys(savedDocuments).map(id => {
        const document = savedDocuments[id];
        return (
            <MenuItem key={id} primaryText={document.name} onClick={() => onClick(id)} />
        );
    });

    return (
      <DropDownMenu style={{backgroundColor: 'white' }} >
          {listItems}
      </DropDownMenu>
    );
};

const DocumentList = (props) => {
    const staticDocumentList = createStaticDocumentList(props.staticDocuments, props.onLoadNewDocument);
    const userDocumentList = createSavedDocumentList(props.userDocuments, props.onLoadExistingDocument);
    return (
        <span>
            {staticDocumentList}
            {userDocumentList}
        </span>

    );
}

export default DocumentList;



// WEBPACK FOOTER //
// ./src/components/document-editor/document_list.jsx